// Central single source of truth for all public-site contact + business info.
// If any of these need to change, update this file only.

export const COMPANY = {
  name: "SchoolLane",
  legalName: "SchoolLane",
  phone: "+91 9674259387",
  phoneHref: "tel:+919674259387",
  email: "schoollane.in@gmail.com",
  emailHref: "mailto:schoollane.in@gmail.com",
  whatsappNumber: "+919674259387",
  whatsappUrl: "https://wa.me/919674259387",
  address: {
    line1: "17/2 Broad Street",
    line2: "Kolkata – 700019",
    line3: "West Bengal, India",
  },
  jurisdiction: "Kolkata, West Bengal, India",
};
